__turbopack_context__.v({
  "disabled": "inputText-module__D8anfa__disabled",
  "error": "inputText-module__D8anfa__error",
  "iconWrapper": "inputText-module__D8anfa__iconWrapper",
  "inputContainer": "inputText-module__D8anfa__inputContainer",
  "inputReset": "inputText-module__D8anfa__inputReset",
  "inputWrapper": "inputText-module__D8anfa__inputWrapper",
  "inputWrapperFocused": "inputText-module__D8anfa__inputWrapperFocused",
  "inputWrapperNoBorder": "inputText-module__D8anfa__inputWrapperNoBorder" + " " + "inputText-module__D8anfa__inputWrapper",
  "noBorder": "inputText-module__D8anfa__noBorder" + " " + "inputText-module__D8anfa__inputWrapper",
  "saigonInput": "inputText-module__D8anfa__saigonInput",
  "textContainer": "inputText-module__D8anfa__textContainer",
});
